import DOMPurify from "isomorphic-dompurify";

DOMPurify.addHook("afterSanitizeAttributes", function (node) {
  if (node.tagName === "A") {
    node.setAttribute("target", "_blank");
    // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
    node.setAttribute("rel", "noopener noreferrer");
  } else {
    // Make sure that only anchor tags allow href
    node.removeAttribute("href");
  }

  return node;
});

const sanitize = (
  dirty: string,
  allowedTags: string[] = [
    "p",
    "a",
    "ul",
    "ol",
    "li",
    "b",
    "i",
    "u",
    "strong",
    "em",
    "strike",
    "br",
    "img",
  ],
  allowedAttributes: string[] = [
    "href",
    "target",
    "rel",
    "class",
    "src",
    "alt",
    "height",
    "width",
  ]
) => {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: allowedTags,
    ALLOWED_ATTR: allowedAttributes,
  });
};

export default sanitize;
